export default "__VITE_ASSET__Du$fF7sn__"